// extracted by mini-css-extract-plugin
module.exports = {"industryDrillDown":"industryDrillDown","industryDrillDown__list":"industryDrillDown__list"};